import axios from "axios";
import * as actionType from "../../constant/actionType";

export const ClientPaidProviderRegistrationInfo = (apidata) => async (dispatch) => {
  /*** API Call Action for Client Paid Provider Registration Info ***/
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/ClientPaidProviderRegistrationInfo`,
      data: apidata,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
